import { apiRequest } from "./apiRequest"

//---------------users--------------
export function serviceLogin(input, password) {
    return apiRequest("/user/login", {
        method: "POST",
        authenticated: false,
        body: { input, password },
    });
}

export const servicePostCreateUser = async (payload) => {
    return apiRequest("/user/create", {
        method: "POST",
        body: payload
    });
}

export const serviceGetAllUsers = async () => {
    return apiRequest("/user/all");
}

export const serviceGetEmployeeInfo = async (employeeId) => {
    return apiRequest(`/user/info/${encodeURIComponent(employeeId)}`);
}

export const serviceUpdateEmployeeInfo = async (payload) => {
    return apiRequest("/user/update", {
        method: "PUT",
        body: payload
    });
}

//---------------products--------------
//add product
export const servicePostNewProduct = async (data) => {
    return apiRequest(
        "/product/create",
        {
            method: "POST",
            body: data
        }
    );
}

export const serviceGetProductDetails = async (productId) => {
    return apiRequest(`/product/details/${encodeURIComponent(productId)}`);
}

export const serviceGetAllProducts = async () => {
    return apiRequest("/product/all");
}

export const serviceUpdateProduct = async (data) => {
    return apiRequest(
        "/product/update",
        {
            method: "PUT",
            body: data
        }
    );
}

export const serviceUpdateProductQuantity = async (data) => {
    return apiRequest(
        "/product/update/quantity",
        {
            method: "PUT",
            body: data
        }
    );
}

export const serviceDeleteProduct = async (productId) => {
    return apiRequest(
        `/product/remove/${encodeURIComponent(productId)}`,
        {
            method: "DELETE",
        }
    );
}

//---------------scale jobs--------------
//get all scale jobs
export const serviceGetAllScaleJobs = async () => {
    return apiRequest("/job/all");
}

//get scale job details
export const serviceGetScaleJobDetails = async (jobId) => {
    return apiRequest(`/job/details/${encodeURIComponent(jobId)}`);
}

//create scale job
export const serviceCreateScaleJob = async (data) => {
    return apiRequest(
        "/job/create",
        {
            method: "POST",
            body: data
        }
    );
}

export const serviceEditScaleJob = async (data) => {
    return apiRequest(
        "/job/update",
        {
            method: "PUT",
            body: data
        }
    );
}

export const serviceDeleteScaleJobDetails = async (jobId) => {
    return apiRequest(
        `/job/remove/${encodeURIComponent(jobId)}`,
        {
            method: "DELETE"
        });
}


//---------------scale parts--------------
export const serviceAddScaleParts = async (jobId, data) => {
    return apiRequest(`/parts/${encodeURIComponent(jobId)}`, {
        method: "POST",
        body: data
    });
}

//---------------scale fitting--------------
export const serviceAddScaleFitting = async (jobId, data) => {
    return apiRequest(`/fitting/${encodeURIComponent(jobId)}`, {
        method: "POST",
        body: data
    });
}
export const serviceUpdateScaleFitting = async (jobId, data) => {
    return apiRequest(`/fitting/${encodeURIComponent(jobId)}`, {
        method: "PUT",
        body: data
    });
}
export const serviceRemoveCommentImageFitting = async (jobId, payload) => {
    return apiRequest(`/fitting/${encodeURIComponent(jobId)}`, {
        method: "PUT",
        body: payload
    });
}

//---------------scale repair--------------
export const serviceAddScaleRepair = async (jobId, data) => {
    return apiRequest(`/repair/${encodeURIComponent(jobId)}`, {
        method: "POST",
        body: data
    });
}

//---------------scale repair parts--------------
export const serviceAddScaleRepairParts = async (repairId, data) => {
    return apiRequest(`/repairparts/${encodeURIComponent(repairId)}`, {
        method: "POST",
        body: data
    });
}